import globalComponents from './global'
import validation from './validation'
import vueSelect from './vue-select'
import ui from './ui'
import modal from './modal'
import fontawesome from './fontawesome'
import toast from './toast'
// Vue 2'de bu eklentiler yalnız kendilerini import eden bileşenin chunk'ı yüklenince global Vue'ya
// kaydoluyordu; createApp uygulaması global Vue'yu görmediği için hepsi burada, açılışta kurulur.
import apexchart from './apexchart'
import vueTagsInput from './vue-tags-input'
import vueSignaturePad from './vue-signature-pad'
import vueEditor from './vue-editor'
import vueSlider from './vue-slider'
import vueDropzone from './vue-dropzone'

export default {
  install(app) {
    [globalComponents, validation, vueSelect, ui, modal, fontawesome, toast,
      apexchart, vueTagsInput, vueSignaturePad, vueEditor, vueSlider, vueDropzone].forEach(plugin => app.use(plugin))
  }
}
